<template>
  <div>
    <!-- 商品信息任务配置 -->
    <div class="productInfoTask">

      <Head />
      <div class="detail">
        <!-- 商品信息任务配置 -->
        <taskConfiguration :options="options" :adminList="adminList" :executeTypeList="executeTypeList"
          :sparkDetail="sparkDetail" />
      </div>
    </div>
  </div>
</template>
<script>
import Head from '@/components/header/detailHeader'
import taskConfiguration from './components/taskConfiguration'

export default {
  components: {
    Head,
    taskConfiguration,
  },

  data() {
    return {
      adminList: [],
      options: [],
      executeTypeList: [],
      sparkDetail: {
        start_at: '',
        desc: [],
        end_at: '',
        msg_receive: [],
        org_id: [],
        execute_by_type: '',
        record_spark_rule: [],
        status: 0,
        switch_status: false,
        execute_by: '',
        id: 0,
      },
    };
  },
  created() {
    // 同组织各工种账号列表
    this.$api.getAuthWorkGroupAdminDepart({ format_list: 1 }).then(res => {
      this.adminList = res.data
    })
    // 执行人
    this.$api.spotCheckApi.executeTypeList().then(res => {
      this.executeTypeList = res.data
    })
    this.$store.dispatch("getOrganizationList");

    let id = this.$route.query.id
    if (id) {
      this.sparkDetail.id = id
      this.recordDetail()
    }
  },
  methods: {
    // 商品信息任务配置详情
    recordDetail() {
      this.$api.spotCheckApi.recordDetail({ id: this.sparkDetail.id }).then(res => {
        res.data.switch_status = res.data.status === 1 ? true : false
        res.data.record_spark_rule.forEach(item => {
          item.condition = JSON.parse(item.condition)
        })
        this.sparkDetail = res.data
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.productInfoTask {
  min-width: 1910px;

  .detail {
    padding: 24px;
    margin: 24px;
    border-radius: 4px;
    background-color: #F8F8F8;


  }
}
</style>